/**
 * 格式化时间
 * @param { string } timeStr: 时间为“YYYY-MM-DD hh:mm:ss”格式的字符串
 */
const formatTime = timeStr => {
    const year = timeStr.slice(0, 4);
    const month = timeStr.slice(5, 10);
    const time = timeStr.slice(11, 16);
    const newsTime = new Date(timeStr);
    const today = new Date();

    let str = newsTime.toDateString();

    // 判断是否为微信或ios
    if (str === 'Invalid Date') {
        const wxNewsTime = new Date(timeStr.replace(/-/g, '/'));

        str = wxNewsTime.toDateString();
    }

    // 判断是否是今天,今年
    let result = '';

    if (str === today.toDateString()) {
        result = `今天 ${time}`;
    } else if (Number(year) === today.getFullYear()) {
        result = `${month} ${time}`;
    } else {
        result = `${year} ${month} ${time}`;
    }

    return result.replace(/\//, '-');
};

export default formatTime;
